<script>
import { euroCouponsThirdpartyMethods, euroCouponsCouponMethods } from "@state/helpers";
import { mapGetters } from "vuex";
import ConfirmRedemption from "./ConfirmRedemption.vue";
import Multiselect from "vue-multiselect";
import { Money } from "v-money";
export default {
  name: "ThirdpartyCouponModal",
  components: { ConfirmRedemption, Multiselect, Money },
  props: {
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      showConfirmRedemption: false,
      loading: true,
      toDetail: {},
      state: "- - -",
      coupon: null,
      customer: null,
      value: null,

      is_internal: null,
      textError: null,
      autogenerate: false,
      redemption_date: null,
      expiration_date: null,
      filterset: null,
      form: {
        code: null,
        document_type: null,
        thirdparty_id: null,
        value_to_redeem: null,
      },
      options: ["CC", "CE", "PEP", "PPT"],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "$ ",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      stores: "captacionPos/stores",
      store: "captacionPos/store",
      cashRegister: "captacionPos/cashRegister",
    }),
  },
  watch: {
    form: {
      deep: true,
      handler(form) {
        let filters_list = [];
        for (let filter in form) {
          if (form[filter]) {
            filters_list.push(`${filter}=${form[filter]}`);
          }
        }
        if (filters_list.length) {
          this.filterset = filters_list.join("&");
        }
        this.filter();
      },
    },
  },

  mounted: function () {
    let context = this;
    if (context.instanceJson.url) {
      context.toDetail = {
        ...context.instanceJson,
      };
      context.form.thirdparty_id = context.instanceJson.id;
      context.autogenerate = context.instanceJson.autogenerate_coupons;
      context.getObject();
    } else {
      context.oncancel();
    }
  },

  methods: {
    ...euroCouponsThirdpartyMethods,
    ...euroCouponsCouponMethods,

    getObject() {
      let context = this;
      const promise = context.fetchEuroCouponsThirdpartyDetail(context.toDetail.url);
      return promise
        .then((data) => {
          context.toDetail = { ...data };
          context.loading = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.loading = false;
          context.oncancel();
        });
    },

    resetData() {
      let context = this;
      context.state = null;
      context.coupon = null;
      context.value = null;
      context.redemption_date = null;
      context.expiration_date = null;
      context.is_internal = null;
    },
    setValue(key, value) {
      this[key] = value;
    },

    setFocus() {
      setTimeout(() => {
        this.$refs["coupon-input"].focus();
      }, 500);
    },

    copyClipboard(value) {
      setTimeout(() => {
        navigator.clipboard.writeText(value);
      }, 500);
    },

    submit() {
      let context = this;
      context.textError = null;
      context.state = "loading";
      // context.submitting = true
      // context.$v.form.$touch()
      // if (context.$v.form.$invalid) {
      //   context.submitting = false
      //   context.$generate_toast(
      //     context,
      //     'error',
      //     context.$t('fill_the_required_fields')
      //   )
      //   return
      // }
      let query = context.filterset ? `?${context.filterset}` : "";
      const promise = context.checkEuroCouponsCoupon(query);
      return promise
        .then((data) => {
          // context.$generate_toast(
          //   context,
          //   'success',
          //   `${context.$t('coupon')} ${
          //     context.action == 'create' ? context.$t('created') : context.$t('updated')
          //   } ${context.$t('correctly')}`
          // )
          setTimeout(() => {
            // context.oncomplete(data.url || null)
            // context.submitting = false
            context.state = data.state;
            context.value = data.value;
            context.expiration_date = data.expiration_date;
            context.redemption_date = data.redemption_date;
            context.is_internal = true
              ? data.type_coupon || data.type_coupon_string
              : null;
            context.coupon = data.id;
          }, 500);
        })
        .catch((error) => {
          // context.submitting = false
          context.resetData();
          context.state = "invalid";
          context.textError = error.response.data.error;
        });
    },
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    ref="couponModal"
    :title="`${$t('detail_of')} ${$t('thirdparty')}`"
    size="lg"
    class="bg-transparent"
    centered
    :hide-header="true"
    :hide-footer="true"
    :no-close-on-esc="false"
    ok-only
    content-class="bg-transparent"
    @hidden="oncancel"
  >
    <b-container class="p-0 bg-transparent">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <!-- <pre>{{instanceJson}}</pre> -->
        <b-col md="12">
          <b-button
            variant="outline-light rounded-circle btn-close shadow"
            @click="() => (modalShow = false)"
            ><i class="fas fa-arrow-left"></i
          ></b-button>
          <div
            class="coupon d-flex flex-column justify-content-center align-items-center"
            :class="{
              'bg-valid': state === 'valid' || state === 'partial_redeemed',
              'bg-expired': state === 'expired' || state === 'redeemed',
              'bg-invalid': state === 'invalid',
            }"
          >
            <div class="icon-animated">
              <sweetalert-icon
                v-if="state === 'valid' || state === 'partial_redeemed'"
                icon="success"
                color="#FFFFFF"
              />
              <sweetalert-icon
                v-else-if="state === 'expired' || state === 'redeemed'"
                icon="info"
                color="#FFFFFF"
              />
              <sweetalert-icon
                v-else-if="state === 'loading'"
                icon="loading"
                color="#FFFFFF"
              />
              <sweetalert-icon
                v-else-if="state === 'invalid'"
                icon="error"
                color="#FFFFFF"
              />
            </div>
            <b-avatar
              rounded
              size="6rem"
              class="shadow mt-3"
              :src="toDetail.logo"
            ></b-avatar>
            <h3 class="text-white">$ {{ value ? $formatDollar(value) : "* * * * *" }}</h3>
            <b-input-group class="mt-2 w-50" v-if="is_internal">
              <Money
                ref="coupon-input"
                id="coupon-input"
                class="form-control bg-transparent border pl-0 text-white border-white unselectable px-2"
                v-model="form.value_to_redeem"
                placeholder="Valor a redimir"
                v-bind="money"
                @input="(value) => {}"
              ></Money>
            </b-input-group>
            <div class="">
              <h3 class="text-white text-center">{{ state ? $t(state) : "- - -" }}</h3>
              <h5
                v-if="state === 'valid' || state === 'partial_redeemed'"
                class="text-white p-0 m-0"
              >
                Bono vigente hasta el {{ $strFormatTimelong(expiration_date) }}
              </h5>
              <h5 v-if="state === 'expired'" class="text-white p-0 m-0">
                El bono expiro el {{ $strFormatTimelong(expiration_date) }}
              </h5>
              <h5 v-if="state === 'redeemed'" class="text-white p-0 m-0">
                Bono redimido el {{ $strFormatTimelong(redemption_date) }}
              </h5>
              <h5 v-if="textError" class="text-white p-0 m-0">{{ textError }}</h5>
            </div>
            <b-input-group id="doctype" size="lg" class="mt-2 w-75 unselectable">
              <template #prepend>
                <b-button
                  v-if="autogenerate"
                  variant="outline-secondary border-right-0 pr-0 text-white border-white"
                  >{{ toDetail.prefix_code }} -&nbsp;</b-button
                >
                <Multiselect
                  v-else
                  v-model="form.document_type"
                  :preselect-first="true"
                  :options="options"
                  :open-direction="'top'"
                  :selected-label="$t('selected')"
                  :select-label="$t('press_enter_to_select')"
                  :deselect-label="$t('press_enter_to_remove')"
                  :placeholder="$t('select_option')"
                  :option-height="48"
                ></Multiselect>
              </template>

              <b-form-input
                ref="coupon-input"
                id="coupon-input"
                class="bg-transparent border-left-0 pl-0 text-white border-white unselectable"
                v-model="form.code"
                :formatter="(value) => value.toUpperCase()"
                :autofocus="true"
                @input="
                  (value) => {
                    resetData();
                    if (!autogenerate) {
                      copyClipboard(value);
                    }
                  }
                "
                @keyup.13="submit"
              ></b-form-input>

              <template #append>
                <b-button
                  id="btn-coupon"
                  class="btn-coupon border-white rounded-right text-dark"
                  @click="submit"
                  >Consultar</b-button
                >
              </template>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="(state === 'valid' || state === 'partial_redeemed') && autogenerate"
        class="justify-content-center mb-2"
      >
        <b-button
          class="rounded shadow"
          style="min-height: 60px; min-width: 300px; font-size: 24px; font-weight: bold"
          variant="light"
          @click="
            () => {
              showConfirmRedemption = true;
            }
          "
          >Redimir</b-button
        >
        <!-- <pre>{{form}}</pre>  -->
      </b-row>
      <b-row
        v-else-if="(state === 'valid' || state === 'partial_redeemed') && !autogenerate"
        class="justify-content-center relative"
      >
        <b-media>
          <template #aside>
            <div>
              <sweetalert-icon icon="info" color="#FFFFFF" />
            </div>
          </template>
          <div class="pt-4">
            <h5 class="w-100 text-center text-white text-shadow">
              El bono se redime de manera automática cuando asocie <b>documento </b> y
              <b>método de pago</b> en la factura.
            </h5>
          </div>
        </b-media>

        <!-- <pre>{{form}}</pre>  -->
      </b-row>
    </b-container>
    <ConfirmRedemption
      v-if="showConfirmRedemption"
      :close-modal="
        () => {
          showConfirmRedemption = false;
          customer = null;
          setFocus();
        }
      "
      :form="{
        thirdparty_id: form.thirdparty_id,
        coupon_id: coupon,
        code: form.code,
        customer: customer,
        CO: store.store_code,
        cash_register: cashRegister.id,
        value: form.value_to_redeem,
        is_internal: is_internal,
      }"
      @set_customer="(value) => setValue('customer', value)"
      @set_state="(value) => setValue('state', value)"
      @set_value="(value) => setValue('value', value)"
      @set_redemption_date="(value) => setValue('redemption_date', value)"
    >
      <!-- :on-submit="submit"
    :submitting="submitting" -->
    </ConfirmRedemption>
  </b-modal>
</template>
<style>
#doctype .multiselect__tags {
  min-height: 48px;
  display: block;
  max-height: 30px;
  padding: 10px 40px 0 8px;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid white;
  border-right: none;
  background: transparent;
  font-size: 14px;
}

#doctype .multiselect__single {
  background: transparent;
  font-size: 20px;
  color: white;
  margin: 0px;
  margin-top: 4px;
}

#doctype .multiselect__input {
  background: transparent;
  font-size: 20px;
  color: white;
  text-transform: uppercase;
}
#doctype .multiselect__input::placeholder {
  background: transparent;
  text-transform: none;

  font-size: 20px;
  color: rgba(255, 255, 255, 0.788);
}

#doctype .multiselect__select {
  margin-top: 6px;
}

#doctype .multiselect--disabled .multiselect__current,
#doctype .multiselect--disabled .multiselect__select {
  background: none;
}

#doctype .multiselect--disabled {
  opacity: 0.3;
}

.coupon {
  width: 660px;
  height: 400px;
  margin: 2rem auto;
  border-radius: 0.5rem;
  /* background: linear-gradient(red,#2c3e50); */
  background-image: linear-gradient(
    140deg,
    hsl(235deg 67% 13%) 0%,
    hsl(230deg 64% 16%) 21%,
    hsl(227deg 62% 20%) 30%,
    hsl(225deg 61% 23%) 39%,
    hsl(222deg 61% 26%) 46%,
    hsl(220deg 63% 29%) 54%,
    hsl(217deg 65% 32%) 61%,
    hsl(215deg 68% 35%) 69%,
    hsl(213deg 72% 37%) 79%,
    hsl(210deg 77% 39%) 100%
  );

  -webkit-mask-image: radial-gradient(circle at 24px 50%, transparent 24px, red 24.5px);
  -webkit-mask-position: -24px;
}

.bg-valid {
  background-image: linear-gradient(
    135deg,
    hsl(135deg 91% 53%) 0%,
    hsl(138deg 100% 46%) 5%,
    hsl(136deg 100% 43%) 10%,
    hsl(133deg 100% 41%) 14%,
    hsl(129deg 100% 39%) 19%,
    hsl(124deg 100% 36%) 23%,
    hsl(120deg 100% 34%) 27%,
    hsl(120deg 100% 32%) 31%,
    hsl(120deg 100% 30%) 35%,
    hsl(120deg 100% 28%) 39%,
    hsl(120deg 100% 25%) 42%,
    hsl(120deg 100% 23%) 46%,
    hsl(120deg 100% 21%) 49%,
    hsl(120deg 100% 19%) 53%,
    hsl(120deg 100% 17%) 56%,
    hsl(120deg 100% 15%) 60%,
    hsl(120deg 100% 13%) 63%,
    hsl(120deg 100% 11%) 67%,
    hsl(120deg 100% 10%) 72%,
    hsl(120deg 100% 9%) 77%,
    hsl(120deg 100% 8%) 83%,
    hsl(0deg 0% 0%) 99%
  );
}

.bg-invalid {
  background-image: linear-gradient(
    135deg,
    hsl(0deg 87% 42%) 0%,
    hsl(357deg 100% 38%) 5%,
    hsl(359deg 100% 36%) 10%,
    hsl(0deg 100% 35%) 14%,
    hsl(0deg 100% 34%) 19%,
    hsl(0deg 100% 33%) 23%,
    hsl(0deg 100% 31%) 27%,
    hsl(0deg 100% 30%) 31%,
    hsl(0deg 100% 29%) 35%,
    hsl(0deg 100% 28%) 39%,
    hsl(0deg 100% 27%) 42%,
    hsl(0deg 100% 26%) 46%,
    hsl(0deg 100% 24%) 49%,
    hsl(0deg 100% 23%) 53%,
    hsl(0deg 100% 22%) 56%,
    hsl(0deg 100% 21%) 60%,
    hsl(0deg 100% 20%) 63%,
    hsl(0deg 100% 19%) 67%,
    hsl(0deg 100% 18%) 72%,
    hsl(0deg 100% 17%) 77%,
    hsl(0deg 100% 16%) 83%,
    hsl(0deg 0% 0%) 99%
  );
}

.bg-expired {
  background-image: linear-gradient(
    135deg,
    hsl(0deg 0% 68%) 0%,
    hsl(344deg 0% 64%) 5%,
    hsl(344deg 0% 61%) 10%,
    hsl(344deg 0% 57%) 14%,
    hsl(344deg 0% 54%) 19%,
    hsl(344deg 0% 51%) 23%,
    hsl(344deg 0% 47%) 27%,
    hsl(344deg 0% 44%) 31%,
    hsl(344deg 0% 41%) 35%,
    hsl(344deg 0% 37%) 39%,
    hsl(344deg 0% 34%) 42%,
    hsl(344deg 0% 31%) 46%,
    hsl(344deg 0% 28%) 49%,
    hsl(344deg 0% 25%) 53%,
    hsl(344deg 0% 22%) 56%,
    hsl(344deg 0% 19%) 60%,
    hsl(344deg 0% 16%) 63%,
    hsl(344deg 0% 14%) 67%,
    hsl(344deg 0% 11%) 72%,
    hsl(343deg 0% 8%) 77%,
    hsl(343deg 0% 5%) 83%,
    hsl(0deg 0% 0%) 99%
  );
}
.coupon::before {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.btn-coupon {
  background-color: white;
}
.btn-coupon:hover {
  background-color: rgb(224, 222, 222);
}
.text-transparent {
  -webkit-text-fill-color: transparent;
}

.coupon .icon-animated {
  position: absolute;
  top: 1.5rem;
  right: 5.5rem;
}

.text-shadow {
  /* background-color: rgba(0, 0, 0, 0.39); */
  font-size: 30px;
  -webkit-text-stroke: 0.2px #000;
  text-shadow: 6px 2px 14px rgb(0, 0, 0);
}

.relative {
  position: relative;
  top: -40px;
}

.btn-close {
  position: absolute;
  background: rgba(22, 6, 163, 0.623);
  left: -65px;
  z-index: 1;
  width: 70px;
  height: 70px;
  font-size: 30px;
}
</style>
